'use client';

import PrimaryButton from '@/components/ui/Button/PrimaryButton';
import RichText from '@/components/ui/RichText/RichText';
import ContentCard from '@/components/molecules/ContentCard/ContentCard';
import SectionGrid from '@/components/ui/SectionGrid/SectionGrid';
import { VisitUsSection } from '@/features/aboutUs/hooks/types';

export default function VisitUsAt({ data }: { data: VisitUsSection }) {
  if (!data) return <p>About Us page not found</p>;

  const { heading, cards = [] } = data;

  return (
    <SectionGrid
      gridClassName="grid grid-cols-1 md:grid-cols-2 gap-6"
      spacingClassName="pt-8 md:pt-10"
    >
      <div className="col-span-full text-center">
        <RichText styles={{ p: 'text-h2 text-theme-primary' }}>
          {heading.content}
        </RichText>
      </div>
      {cards.map((item) => (
        <ContentCard
          key={item?.content}
          variant="image"
          image={item?.imageUrl}
          imageMode="cover"
          heading={item?.content}
          subheading={item?.subtitle}
          description={item?.description}
          fontStyle="font-normal"
          button={
            item?.btnText ? (
              <PrimaryButton
                data={{
                  title: item.btnText,
                  slug: item.slug,
                  functionality: item.functionality || 'custom',
                }}
              />
            ) : undefined
          }
        />
      ))}
    </SectionGrid>
  );
}
